<template>
    <v-container class="fill-height justify-start align-start">
        <v-row>
            <v-col class="v-col-lg-6 v-col-md-8">
                <v-card>
                    <v-toolbar>
                        <v-toolbar-title>{{ title }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form @submit.prevent="save">
                            <v-text-field variant="outlined" density="compact" label="Part Number"
                                v-model="partNumber"></v-text-field>
                            <v-text-field variant="outlined" density="compact" label="Lot Number"
                                v-model="lotNumber"></v-text-field>
                            <v-text-field variant="outlined" density="compact" label="Box Number"
                                v-model="boxNumber"></v-text-field>
                            <v-text-field variant="outlined" density="compact" label="Production Date"
                                v-model="productionDate"></v-text-field>
                            <v-text-field variant="outlined" density="compact" label="Box Count"
                                v-model="boxUnits"></v-text-field>
                            <v-text-field variant="outlined" density="compact" label="Ok Count"
                                v-model="goodPartsUnit"></v-text-field>
                            <v-row v-for="(item, index) in defectDetails" :key="item.defectDetailId">
                                <v-col><v-text-field variant="outlined" density="compact" label="Defect Count"
                                        v-model="item.count"></v-text-field></v-col>
                                <v-col><v-text-field variant="outlined" density="compact" label="Defect Type"
                                        v-model="item.description"></v-text-field>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn icon="mdi-delete" variant="text" @click="removeDefect(index)"></v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="d-flex justify-end">
                                    <v-btn icon="mdi-plus" color="primary" @click="addDefect"></v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn variant="elevated" class="ml-2 mr-3" @click="goBack">Back</v-btn>
                        <v-btn variant="elevated" color="primary" class="mr-3" @click="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar">{{ message }}
            <template v-slot:actions>
                <v-btn icon="mdi-close" variant="text" @click="snackbar = false" :timeout="timeout"></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>


<script>
import ReportDetailsApi from '../services/ReportDetailsApi'
import { useStore } from '../services/store'


export default {
    name: "ReportDetailsEdit",
    data() {
        return {
            title: "",
            id: 0,
            reportId: 0,
            boxNumber: "",
            boxUnits: 0,
            defectDetails: [{ count: 0, description: '' }],
            defectTotalCount: 0,
            goodPartsUnit: 0,
            lotNumber: "",
            partNumber: "",
            productionDate: "",
            message: "",
            timeout: 2000,
            snackbar: false
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.reportId = this.$route.params.reportId;

        if (!isNaN(this.id) && this.reportId > 0) {
            this.title = "Edit";
            ReportDetailsApi.get(this.reportId, this.id).then((response) => {
                if (response && response.data) {
                    this.boxNumber = response.data.boxNumber;
                    this.boxUnits = response.data.boxUnits;
                    this.createdDate = response.data.createdDate;
                    this.defectDetails = response.data.defectDetails;
                    this.defectTotalCount = response.data.defectTotalCount;
                    this.goodPartsUnit = response.data.goodPartsUnit;
                    this.lotNumber = response.data.lotNumber;
                    this.partNumber = response.data.partNumber;
                    this.productionDate = response.data.productionDate;
                }
            })
        }
        else {
            this.title = "Create";
        }
    },
    methods: {
        save() {
            this.defectTotalCount = 0;
            if (Array.isArray(this.defectDetails)) {
                for (var i in this.defectDetails) {
                    var c = this.defectDetails[i].count;
                    if(!isNaN(c) )
                        this.defectTotalCount += parseInt(c, 10);
                }
            }
            let payload = {
                reportDetailId: !isNaN(this.id) ? this.id : undefined,
                reportId: this.reportId,
                boxNumber: this.boxNumber,
                boxUnits: this.boxUnits,
                createdDate: this.createdDate,
                defectDetails: this.defectDetails,
                defectTotalCount: this.defectTotalCount,
                goodPartsUnit: this.goodPartsUnit,
                lotNumber: this.lotNumber,
                partNumber: this.partNumber,
                productionDate: this.productionDate
            };
            if (!isNaN(this.id) && this.id > 0) {
                ReportDetailsApi.put(this.reportId, this.id, payload).then((response) => {
                    if (response && response.data) {
                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                });
            }
            else {
                ReportDetailsApi.post(this.reportId, payload).then((response) => {
                    if (response && response.data) {
                        this.id = response.data.reportDetailId;
                        this.$router.push(`/reports/${this.reportId}/details/${this.id}`);
                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                });
            }
        },
        goBack() {
            const store = useStore();
            store.showDetails = true;

            this.$router.push(`/reports/${this.reportId}`)
        },
        addDefect() {
            this.defectDetails.push({ count: 0, description: ''});
        },
        removeDefect(index) {
            this.defectDetails.splice(index, 1);
        }
    }
}

</script>